var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermanentSnowMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8211_19014",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F8F8F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8211_19014)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31,
    r: 6,
    fill: "#B0D0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 6,
    fill: "#DAEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8876 31.9514L14 64H62L44.1124 31.9514C41.4419 27.1668 34.558 27.1668 31.8876 31.9514Z",
    fill: "url(#paint0_linear_8211_19014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 41.6316L3 64H60L38.75 41.6316C34.8074 37.4816 28.1925 37.4816 24.25 41.6316Z",
    fill: "url(#paint1_linear_8211_19014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 48L21.3751 51.0001C23.2999 52.7109 26.2003 52.7109 28.1251 51C30.0498 49.2891 32.9503 49.2891 34.8751 51C36.7998 52.7109 39.7003 52.7109 41.625 51L45 48",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8211_19014",
    x1: 38,
    y1: 28.351,
    x2: 38,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8211_19014",
    x1: 31.5,
    y1: 39.1286,
    x2: 31.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentSnowMain);
export default __webpack_public_path__ + "static/media/permanentSnow-main.8cfd1826f4119528dac072ae0b56f6a4.svg";
export { ForwardRef as ReactComponent };